import store from '@/store'
import {Message, MessageBox} from 'element-ui';

//保存数据不带ID为新增，带ID为更新
const checkBillState = async (params, billType) => {
    let info_param = {
        url: "/systemoptions/getNewSystemInfo",
        param: {}
    }
    const info_data = await store.dispatch('pubMethod', info_param)
    const monthStart = new Date(info_data.data.result.monthStart);
    const monthEnd = new Date(info_data.data.result.monthEnd);

    let param = {
        url: "/systemoptions/getNewSystemOptions",
        param: {}
    }
    const data = await store.dispatch('pubMethod', param)
    let result = data.data;
    const mustReview = result.mustReview;
    const modifyBill = result.modifyBill;
    const modifyBillFlag = result.modifyBillFlag;
    const loginName = result.loginName;

    const bill_data = await store.dispatch('pubMethod', params)
    if (bill_data.infoCode == "0") {
        const ret = bill_data.data
        const makeBy = ret.makeBy;
        //const billDate = new Date(ret.billDate);
        const reviewState = ret.reviewState;
        const cancelState = ret.cancelState;

        if (modifyBill == 0) {
            Message({message: '选项设置为账单不允许修改', type: 'error'});
            return false;
        }
        if (modifyBillFlag == 0 && loginName != makeBy) {
            Message({message: '你没有修改他人账单的权限', type: 'error'});
            return false;
        }
        /*if ((monthStart > billDate || monthEnd < billDate) && billType != 'ProjectCheckBill'
            && billType != 'CommCheckBill' && billType != 'AssetsCheckBill' && billType != 'ConsumCheckBill'
            && billType != 'SupplyOrder' && reviewState != '-2') {
            Message({message: '非当前记账月份内账单不允许被修改', type: 'error'});
            return false;
        }*/
        if (cancelState == 1) {
            Message({message: '账单已被撤销', type: 'error'});
            return false;
        }
        if (reviewState >= 0 && mustReview == 1) {
            Message({message: '账单已被审核', type: 'error'});
            return false;
        }
    }
    return true;
}

const checkFlow = async (params,model_key,reviewAll_param,that) => {
    let option_param = {
        url: "/systemoptions/getNewSystemOptions",
        param: {}
    }
    const option_data = await store.dispatch('pubMethod', option_param)
    let result = option_data.data;
    const loginName = result.loginName;

    const data = await store.dispatch('pubMethod', params)
    if (data.infoCode == "0") {
        if (data.data) {
            console.log(loginName+'1')
            console.log(data.data.makeBy)
            if (data.data.makeBy != loginName) {
                Message({message: '仅制单人才能提交审核!', type: 'error'});
                return false;
            }
            if (data.data.cancelState == "1") {
                Message({message: '账单已被撤销!', type: 'error'});
                return false;
            }
            if (data.data.reviewState >= 0) {
                Message({message: '账单已被提交或已被审核!', type: 'error'});
                return false;
            }
        } else {
            Message({message: '账单不存在!', type: 'error'});
            return false;
        }
    }

    //查询是否存在该流程
    let getModel_param = {
        url: "/fhmodel/getModel",
        param: {
            KEY_: model_key
        }
    }
    const getModel_data = await store.dispatch('pubMethod', getModel_param)
    if (getModel_data.infoCode == "0") {
        if (getModel_data.data) {

        } else {
            MessageBox.confirm('审批流没设置，询问是否继续?', '提交审核提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const data = await store.dispatch('pubMethod', reviewAll_param)
                if (data.infoCode == "0") {
                    that.refresh();
                }
            }).catch(() => {
            })
            return false;
        }
    }
    return true;
}


export default {
    checkBillState, checkFlow
}